import { MobileBottomNav } from './MobileBottomNav';
/**
 * Mobile App Wrapper
 * ==================
 * 
 * Wrapper que detecta la plataforma y aplica configuraciones específicas.
 */

import React, { useEffect, useState } from 'react';
import { useNativeApp } from '../../hooks/useNativeApp';
import { useOfflineSync } from '../offline/useOfflineSync';
import '../../styles/mobile.css';

export const MobileAppWrapper = ({ children }) => {
  const { isNative, isIOS, isAndroid, appInfo, requestNotificationPermission } = useNativeApp();
  const [notificationPermissionRequested, setNotificationPermissionRequested] = useState(false);

  // Ola 2 · O2.5: envía lo hecho sin conexión al abrir la app y al recuperar
  // red (inactivo salvo REACT_APP_OFFLINE_ENABLED=true; el servicio comprueba
  // sesión y conexión y usa un mutex).
  useOfflineSync();

  useEffect(() => {
    // Aplicar clase de plataforma al body
    if (isIOS) {
      document.body.classList.add('ios-app');
    } else if (isAndroid) {
      document.body.classList.add('android-app');
    }

    if (isNative) {
      document.body.classList.add('native-app');
      
      // Deshabilitar bounce scroll en iOS
      document.body.style.overscrollBehavior = 'none';
    }

    return () => {
      document.body.classList.remove('ios-app', 'android-app', 'native-app');
    };
  }, [isIOS, isAndroid, isNative]);

  // Solicitar permisos de notificación después de un tiempo
  useEffect(() => {
    if (isNative && !notificationPermissionRequested) {
      const timer = setTimeout(async () => {
        await requestNotificationPermission();
        setNotificationPermissionRequested(true);
      }, 5000); // Esperar 5 segundos antes de pedir permisos

      return () => clearTimeout(timer);
    }
  }, [isNative, notificationPermissionRequested, requestNotificationPermission]);

  return (
    <div className={`app-container ${isNative ? 'mobile-container' : ''}`}>
      {/* Contenido principal */}
      <main className={`${isNative ? 'pb-20' : ''}`}>
        {children}
      </main>

      {/* Navegación inferior solo en app nativa */}
      {isNative && <MobileBottomNav />}

      {/* Indicador de versión en desarrollo */}
      {process.env.NODE_ENV === 'development' && appInfo && (
        <div className="fixed bottom-20 left-2 text-xs text-gray-400 bg-white/80 px-2 py-1 rounded z-50">
          {appInfo.platform} v{appInfo.version}
        </div>
      )}
    </div>
  );
};

export default MobileAppWrapper;
